import React, { useState, useEffect } from "react";

import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { BsFillEyeFill } from "react-icons/bs";
import ReactPaginate from "react-paginate";
import "./User.css";
import { FaPlus } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { makeAuthenticatedGETRequest } from "../../services/serverHelper";
import AdminNavbar from "../../Admin/Navbar/Navbar1";
import { useNavigate } from "react-router-dom";



const BASE_URL = process.env.REACT_APP_BASE_URL;

const UserArtist = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterOption, setFilterOption] = useState("0");
  const [selectedUsers, setSelectedUsers] = useState([]);

  const token = localStorage.getItem("accessToken");
  const navigate = useNavigate();

  const itemsPerPage = 10;

  useEffect(() => {
    const getUser = async () => {
      const toastId = toast.loading("Loading...");
      try {
        const response = await fetch(
          `https://api.ekalakaar.com/api/v1/admin/user?role=${getRoleByFilterOption()}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const responseData = await response.json();
        setData(responseData.data);
        toast.dismiss(toastId);

        switch (filterOption) {
          case "0":
            toast.success("Artists loaded successfully");
            break;
          case "1":
            toast.success("Patrons loaded successfully");
            break;
          case "2":
            toast.success("Partners loaded successfully");
            break;
          case "3":
            toast.success("Art-Lovers loaded successfully");
            break;
          default:
            break;
        }
      } catch (error) {
        console.error("Error fetching artist data:", error);
        toast.dismiss(toastId);
        toast.error("Failed to load data");
      }
    };

    getUser();
  }, [filterOption]);

  const getRoleByFilterOption = () => {
    switch (filterOption) {
      case "1":
        return "Patron";
      case "2":
        return "Partner";
      case "3":
        return "Art-lover";
      default:
        return "Artist";
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(0);
  };

  const handleFilterChange = (e) => {
    setFilterOption(e.target.value);
    setSearchQuery("");
    setCurrentPage(0);
    setSelectedUsers([]);
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  const handleDelete = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this user?");
    if (!confirmDelete) return;

    const toastId = toast.loading("Deleting user...");

    try {
      const response = await fetch(`${BASE_URL}/admin/deleteuser/${userId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (response.ok) {
        toast.update(toastId, {
          render: "User deleted successfully",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        setData((prevData) => prevData.filter((user) => user._id !== userId));
      } else {
        throw new Error(result.message || "Failed to delete user");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.update(toastId, {
        render: `Error: ${error.message}`,
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleBulkDelete = async () => {
    if (selectedUsers.length === 0) {
      toast.warning("Please select at least one user.");
      return;
    }

    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${selectedUsers.length} user(s)?`
    );
    if (!confirmDelete) return;

    const toastId = toast.loading("Deleting selected users...");

    try {
      const deletePromises = selectedUsers.map((userId) =>
        fetch(`${BASE_URL}/admin/deleteuser/${userId}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
      );

      await Promise.all(deletePromises);

      setData((prevData) => prevData.filter((user) => !selectedUsers.includes(user._id)));
      setSelectedUsers([]);

      toast.update(toastId, {
        render: "Selected users deleted successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (err) {
      toast.update(toastId, {
        render: `Error: ${err.message}`,
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const filteredData = data.filter(
    (item) =>
      item.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (item.phoneNumber && item.phoneNumber.number.includes(searchQuery))
  );

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  function toggleBlock(e) {
    if (e.target.textContent === "Block") {
      e.target.style.color = "#00FF38";
      e.target.textContent = "Unblock";
    } else {
      e.target.style.color = "#FF0018";
      e.target.textContent = "Block";
    }
  }

  function toggleApproved(e) {
    if (e.target.textContent === "Rejected") {
      e.target.style.color = "#00FF38";
      e.target.textContent = "Approved";
    } else {
      e.target.style.color = "#FF0018";
      e.target.textContent = "Rejected";
    }
  }

  function toggleverify(e) {
    if (e.target.textContent === "Verify") {
      e.target.style.color = "#00FF38";
      e.target.textContent = "Verified";
    } else {
      e.target.style.color = "#FC9904";
      e.target.textContent = "Verify";
    }
  }

  return (
    <>
    <AdminNavbar /><div className="usercontainer">
      
      <div className="row-container">
        <h2>
          Manage Users -
          <span style={{ color: "#AD2F3B" }}>
            {filterOption === "0" && "Artists"}
            {filterOption === "1" && "Patrons"}
            {filterOption === "2" && "Partners"}
            {filterOption === "3" && "Art-Lovers"}
          </span>
        </h2>
        <FaPlus className="plus" title={`Add ${getRoleByFilterOption()}`} />
      </div>

      <div className="filter-dropdown">
        <div className="searchbar">
          <IoSearch className="searchicon" />
          <input
            type="search"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
        <div className="filterdrop">
          Filter
          <select
            className="artistfilter"
            onChange={handleFilterChange}
            value={filterOption}
          >
            <option value="0">Artist</option>
            <option value="1">Patron</option>
            <option value="2">Partner</option>
            <option value="3">Art-Lover</option>
          </select>
        </div>
      </div>

      <button
        className="delete-selected-button"
        onClick={handleBulkDelete}
        style={{ marginBottom: "10px", background: "#AD2F3B", color: "#fff", padding: "6px 12px", border: "none", borderRadius: "4px", cursor: "pointer" }}
      >
        Delete Selected
      </button>

      <table>
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedUsers(currentItems.map((item) => item._id));
                  } else {
                    setSelectedUsers([]);
                  }
                }}
                checked={
                  selectedUsers.length === currentItems.length &&
                  currentItems.length > 0
                }
              />
            </th>
            <th>Custom Id</th>
            <th>First<br />Name</th>
            <th>Email</th>
            <th>Phone No</th>
            <th>Registered<br />On</th>
            <th>Block/<br />Unblock</th>
            <th>Approve/<br />Reject</th>
            <th>Verify</th>
            <th className="viewicon">
              <FaRegEdit title="Edit" className="edit" />
              <BsFillEyeFill title="View" className="view" />
              <RiDeleteBin6Line title="Delete" className="delete" />
            </th>
          </tr>
        </thead>
        <tbody className="table_body">
          {currentItems.map((item, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedUsers.includes(item._id)}
                  onChange={() => {
                    setSelectedUsers((prev) =>
                      prev.includes(item._id)
                        ? prev.filter((id) => id !== item._id)
                        : [...prev, item._id]
                    );
                  }}
                />
              </td>
              <td>{item.customID}</td>
              <td>{item.firstName}</td>
              <td>{item.email}</td>
              <td>{item.phoneNumber?.number}</td>
              <td>{item.createdAt}</td>
              <td className="block" onClick={(e) => toggleBlock(e)}>
                {item.blocked ? "Unblock" : "Block"}
              </td>
              <td className="approve" onClick={(e) => toggleApproved(e)}>
                {item.approved ? "Approved" : "Rejected"}
              </td>
              <td className="verify" onClick={(e) => toggleverify(e)}>
                {item.approved ? "Verify" : "Verified"}
              </td>
              <td className="viewicon">
                <FaRegEdit title="Edit" className="edit" />
                <BsFillEyeFill
                  title="View"
                  onClick={() => {
                    localStorage.setItem("artId", item._id);
                    navigate("/artistProfile");
                  }}
                  className="view"
                />
                <RiDeleteBin6Line
                  title="Delete"
                  className="delete"
                  onClick={() => handleDelete(item._id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <ReactPaginate
        previousLabel={"<"}
        nextLabel={">"}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}
      />
    </div>
    </>
  );
};

export default UserArtist;